import type {AxiosResponse} from 'axios';
import axios from 'axios';
import {baseUrl} from 'config/utils';

const jwtAxios = axios.create({
  // baseURL: baseUrl,
  // baseURL: 'http://localhost:3009/api/v1',
  baseURL: 'https://api.appcrops.com/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

jwtAxios.interceptors.response.use(
  (res: AxiosResponse<any, any>) => res,
  (err: any) => {
    if (err.response && err.response.data.msg === 'Token is not valid') {
      console.log('Need to logout user');
    }
    return Promise.reject(err);
  },
);

export const setAuthToken = (token?: string) => {
  if (token) {
    jwtAxios.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem('TokenAppcropsAdmin', token);
  } else {
    delete jwtAxios.defaults.headers.common.Authorization;
    localStorage.removeItem('TokenAppcropsAdmin');
  }
};

export default jwtAxios;
